<template>
  <v-layout style="min-width: fit-content" v-show="!!allowedApps && !!allowedApps.length" row wrap justify-center :class="{ 'appContainer': $vuetify.breakpoint.mdAndUp }">
   <!-- :style="`${index % 2 ? 'padding: 4px 0px 4px 2px' : 'padding: 4px 2px 4px 0px'}`" -->
    <v-flex v-for="app in allowedApps" :key="app.icon" xs6>
      <v-btn outlined outline color="primary" :href="app.url">
        <v-layout row align-center class="clickable">
          <v-flex justify-center xs1 style="max-width: 30px; margin-right: 4px">
            <v-icon>
              {{ app.icon }}
            </v-icon>
          </v-flex>

          <v-flex xs11>
            <div
              :class="{
                'text-size-1': $vuetify.breakpoint.mdAndUp,
                'text-size-sub': !$vuetify.breakpoint.mdAndUp
              }"
            >
              {{ $vuetify.t('$vuetify.apps.'+app.name) }}
            </div>
          </v-flex>
        </v-layout>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import get from 'lodash/get';

import { mapGetters } from 'vuex';

export default {
  computed: {
    allowGiftCard() {
      return get(this.getStore, 'features.selfcareGiftcardSupported', false)
    },
    allowDeposit() {
      return get(this.getStore, 'features.selfcareMembershipDepositSupported', false)
    },
    allowLineup() {
      return !get(this.getStore, 'settings.owaSettings.hideLineup', false)
        && get(this.getStore, 'features.webLineupSupported', false)
        && get(this.getStore, 'settings.webLineupSettings.webLineupEnabled', false)
        && get(this.getStore, 'features.inStoreLineupSupported', false)
    },
    allowReservation() {
      return get(this.getStore, 'features.cpReservationSupported', false)
        && get(this.getStore, 'features.inStoreReservationSupported', false)
        && get(this.getStore, 'settings.webReservationSettings.webReservationEnabled', false)
    },

    buildGiftCard() {
      return {
        url: this.buildGiftCardAppsUrl('GiftCard'),
        icon: 'card_giftcard',
        name: 'giftcard'
      }
    },
    buildDeposit() {
      return {
        url: this.buildGiftCardAppsUrl('Deposit'),
        icon: 'account_balance',
        name: 'deposit'
      }
    },
    buildLineup() {
      return {
        url: this.buildAngularAppsUrl('lineup'),
        icon: 'people',
        name: 'lineup'
      }
    },
    buildReservation() {
      return {
        url: this.buildAngularAppsUrl('reservation'),
        icon: 'event',
        name: 'reservation'
      }
    },

    allowedApps() {
      return [
        this.allowReservation ? this.buildReservation : null,
        this.allowLineup ? this.buildLineup : null,
        this.allowGiftCard ? this.buildGiftCard : null,
        this.allowDeposit ? this.buildDeposit : null
      ].filter(Boolean)
    },

    customer() {
      return this.getCustomer || {}
    },

    ...mapGetters([
      'getStore',
      'getCustomer',
      'getCustomerRewards',
      'isLoggedIn',
      'getAuthToken'
    ])
  },

  methods: {
    buildGiftCardAppsUrl(route) {
      // Allow stores to have the entire group be directed to the same store id on giftcard
      const storeId = get(this.getStore, 'settings.rewardsSettings.selfcareGiftcardSharedStoreId', this.getStore.storeId)

      let url = `${process.env.VUE_APP_APP_BASE}/giftcard/${storeId}`
      url += `?feature=${route}`
      url += `&returnUrl=${window.location.href}`

      url += this.addUserDetails('11111')

      return url
    },
    buildContactTracingUrl() {
      let url = `${process.env.VUE_APP_APP_BASE}/contact_tracing/?storeId=${this.getStore.storeId}`
      url += `&returnUrl=${window.location.href}`

      url += `&first=${this.customer.firstName}`
      url += `&last=${this.customer.lastName}`
      url += `&telephone=${this.customer.telephone}`

      return url
    },
    buildAngularAppsUrl(route) {
      let url = `${process.env.VUE_APP_APP_BASE}/${route}/`
      url += `?storeId=${this.getStore.storeId}`

      if (route == 'lineup') {
        url += '&force=true&noSms=true'
      }

      url += this.addUserDetails('11001')
      url += `&returnUrl=${window.location.href}`

      return url
    },

    addUserDetails(paramFlags) {
      let string = ''

      if (this.isLoggedIn) {
        string += paramFlags[0] == 1 ? `&name=${this.customer.firstName} ${this.customer.lastName}` : ''
        string += paramFlags[1] == 1 ? `&telephone=${this.customer.telephone}` : ''
        string += paramFlags[2] == 1 ? `&email=${this.customer.email}` : ''
        string += paramFlags[3] == 1 ? `&authorizationId=${this.getAuthToken}` : ''

        // No other apps support french yet
        string += paramFlags[4] == 1 && this.$vuetify.lang.current != 'fr'
          ? `&lang=${this.$vuetify.lang.current == 'zhHans' ? 'zh' : this.$vuetify.lang.current}`
          : ''
      } else if (paramFlags[3] == 1) {
        string +=  `&authorizationId=${null}`

        // No other apps support french yet
        string += paramFlags[4] == 1 && this.$vuetify.lang.current != 'fr'
          ? `&lang=${this.$vuetify.lang.current == 'zhHans' ? 'zh' : this.$vuetify.lang.current}`
          : ''
      }

      return string
    },

    hasStoreImage() {
      return !!get(this.getStore, 'images.MAIN[0].url')
    }
  }
}
</script>

<style scoped>
  .appContainer {
    max-width: 450px !important;
    padding-bottom: 5px;
    
    margin: auto;
  }
  .appContainer.left-align {
    margin: 0px !important;
  }

  .flex.xs6:nth-child(2n) {
    padding: 5px 5px 5px 2.5px;
  }
  .flex.xs6:nth-child(2n+1) {
    padding: 5px 2.5px 5px 5px;
  }

  @media (max-width: 320px) {
    .flex.xs6 {
      flex-basis: 100%;
      flex-grow: 0;
      max-width: 100%;
    }
    .flex.xs11 .text-size-sub {
      font-size: var(--text-size-1) !important;
    }
  }
  
  
  .v-btn {
    border-radius: 20px;
    width: 100%;

    text-transform: none !important;
    text-align: left !important;
    padding: 5px !important;
  }
  a, .v-btn {
    margin: 0px !important;
    font-size: var(--text-size-1);
  }
</style>
